
<div class="main">



  <div class="container" >
    <div id="rend">
        <img id="img-s" style="display: none;" src="assets/MSxJ1p1SgQg.jpg" alt="">
        <img class="displace" style="display: none;" src="assets/rocks.png" alt="">
        <img class="displace2" style="display: none;" src="assets/displace_002.jpg" alt="">
    </div>
    <div *ngIf="isMobile">
      <img src="assets/MSxJ1p1SgQg.jpg" alt="" style="width: auto; height: 300px;">
    </div>
    <div class="">
      <p>Hi! 😊  My name is Dima Nikolaev.</p>
      <p>I am a Web Developer</p>
      <p>and now I live on the DOM tree)</p>
      <p>Here is my 2014 - 2021 portfolio</p>
    </div>
<!--      <div class="person-">-->
<!--        <img [src]="!hoveredAva ? 'assets/ava.jpg' : 'assets/ava-hover.jpg'"-->
<!--             (mouseover)="hoveredAva=true" (mouseleave)="hoveredAva=false"-->
<!--          alt="avatar" style="width: 100px; height: 100px; border-radius: 100%;">-->
<!--        <div style="float: right; margin-left: 1em;">-->


<!--  <div class="container" style="font-family: 'Zilla Slab', serif;">-->

<!--    </div>-->

<!--  </div>-->
<!--&lt;!&ndash;  <div >&ndash;&gt;-->

<!--&lt;!&ndash;    <div class="" style="border-radius: 1em;">&ndash;&gt;-->
<!--&lt;!&ndash;&ndash;&gt;-->

  <div *ngFor="let year of years">
    <h2 class="year-block">{{ year }}</h2>

    <ng-container *ngFor="let it of portfolioItems; let i = index;">
      <ng-container *ngIf="it.year == year">
        <app-preview-item style=" position: relative;" [item]="it"></app-preview-item>
      </ng-container>
    </ng-container>
  </div>

<!--      <div *ngFor="let year of years">-->
<!--        <div style="background: red;">-->
<!--          <h2 style="margin: 0.3em; width: 120px;" class="">{{ year }}</h2>-->
<!--          <h2 style="margin: 0.3em; width: 120px;" class="double-h2">{{ year }}</h2>-->
<!--        </div>-->
<!--&lt;!&ndash;        <h2 style=" position: relative;">222</h2>&ndash;&gt;-->
<!--        <div>-->
<!--          <ng-container *ngFor="let it of portfolioItems; let i = index;">-->
<!--            <ng-container *ngIf="it.year == year">-->
<!--              <app-preview-item style=" position: relative;" [item]="it"></app-preview-item>-->
<!--            </ng-container>-->
<!--          </ng-container>-->
<!--        </div>-->
<!--      </div>-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->

<!--&lt;!&ndash;    <div *ngFor="let year of years" class="row">&ndash;&gt;-->
<!--&lt;!&ndash;      &ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->

  </div>
</div>
